<template>
  <BaseDialog type="basic" :title="title" :is-open="isOpen" @close="emits('close')">
    <ul v-if="texts.length > 0" class="flex flex-col gap-2">
      <li v-for="text in texts" :key="text.question.id">
        <SelectableTextFeedbackItem
          :text-feedbacks="text"
          :selected-feedback-ids="selectedFeedbackIds"
          @toggle-feedback="toggleFeedback"
        />
      </li>
    </ul>
    <div v-else class="mb-4 flex flex-col items-center justify-center">
      <EmptyQuestions hight-contrast />
      <h4 class="text-title-large text-on-surface text-center">Keine Daten verfügbar</h4>
      <p class="text-body-medium text-on-surface-variant max-w-md text-center">
        Es liegen aktuell keine passenden Daten vor. Bitte wähle eine andere Umfrage, hole neues
        Feedback ein oder lass dieses Feld leer.
      </p>
    </div>
    <template #dismiss
      ><BaseTextButton @click="emits('close')">{{ $t('common.cancel') }}</BaseTextButton></template
    >
    <template #confirm
      ><BaseTextButton @click="selectFeedbacks">Auswählen</BaseTextButton></template
    >
  </BaseDialog>
</template>
<script lang="ts" setup>
  import { ref, watch } from 'vue'
  import BaseDialog from '../../../core/components/base/dialog/BaseDialog.vue'
  import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'
  import type { TextAnalysis } from '@/core/models/surveys-analytics'
  import SelectableTextFeedbackItem from './SelectableTextFeedbackItem.vue'
  import EmptyQuestions from '@/core/components/analytics/question-list/EmptyQuestions.vue'

  interface Props {
    title: string
    isOpen: boolean
    texts: ReadonlyArray<TextAnalysis>
    initialFeedbackIds: string[]
  }
  const { texts, initialFeedbackIds } = defineProps<Props>()

  const selectedFeedbackIds = ref(new Set(initialFeedbackIds))

  watch(
    () => initialFeedbackIds,
    () => {
      selectedFeedbackIds.value.clear()
      for (const feedbackId of initialFeedbackIds) {
        selectedFeedbackIds.value.add(feedbackId)
      }
    },
  )

  const emits = defineEmits<{
    (e: 'close'): void
    (e: 'selectFeedbacks', feedbackIds: string[]): void
  }>()

  const selectFeedbacks = () => {
    emits('selectFeedbacks', [...selectedFeedbackIds.value])
    emits('close')
  }

  const toggleFeedback = (feedbackId: string) => {
    if (selectedFeedbackIds.value.has(feedbackId)) {
      selectedFeedbackIds.value.delete(feedbackId)
    } else {
      selectedFeedbackIds.value.add(feedbackId)
    }
  }
</script>
